import { assert } from '../../lib/assert-sidecar'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewCarryCommand } from './multi/voyageMessageCrewCarry'
import { voyageMessageCrewCarry } from './multi/voyageMessageCrewCarry-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export function onEnter(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  if (voyageWebsockets.getIsHost()) {
    // if (voyageCrew.isHolding(obj, EVoyageCarryableType.BattleRifle)) {
    let coffee = voyageCrew.getItemSafe(obj, EVoyageCarryableType.Coffee)
    if (!coffee) {
      if (obj.crewState) {
        obj.crewState.coffeeSteps = 200
      }
      voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
        command: EVoyageCrewCarryCommand.Create,
        type: EVoyageCarryableType.Coffee,
        crewId: obj.id,
        carryId1: createId(),
        carryId2: 0,
        i: obj.i,
        j: obj.j,
      })
    } else if (voyageCrew.isHolding(obj, EVoyageCarryableType.Coffee)) {
      if (obj.crewState) {
        obj.crewState.coffeeSteps = 0
      }
      voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
        command: EVoyageCrewCarryCommand.Destroy,
        type: EVoyageCarryableType.Coffee,
        crewId: obj.id,
        carryId1: coffee.id,
        carryId2: 0,
        i: obj.i,
        j: obj.j,
      })
    }
  }

  // if (!obj.carryable) {
  //   obj.carryable = voyageCarryable.create(EVoyageCarryableType.Coffee)
  //   voyageCarryable.moveToXY(obj.carryable, obj.x, obj.y)
  // } else if (
  //   obj.carryable &&
  //   obj.carryable.type === EVoyageCarryableType.Coffee
  // ) {
  //   voyageCarryable.kill(obj.carryable)
  //   obj.carryable = null
  // }
}
